"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("@/config/constants");
var _ModalEditDataArea = _interopRequireDefault(require("./ModalEditDataArea"));
var _ListBunchesAreas = _interopRequireDefault(require("./ListBunchesAreas"));
var _ModaNewItems = _interopRequireDefault(require("./ModaNewItems"));
var _vuex = require("vuex");
var _ButtonQRCode = _interopRequireDefault(require("./ButtonQRCode"));
var _this2 = void 0;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default2 = exports.default = {
  name: 'ListFamilies',
  components: {
    ListBunchesAreas: _ListBunchesAreas.default,
    ButtonQRCode: _ButtonQRCode.default
  },
  props: {
    row: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      modal: null,
      familiesItems: [],
      totalFamilies: 0,
      filter: '',
      pageActive: 1,
      limit: 20,
      rangeBefore: 3,
      rangeAfter: 1
    };
  },
  mounted: function mounted() {
    this.getFamiliesRest();
  },
  computed: {
    filteredFamilies: function filteredFamilies() {
      var _this = this;
      var arrayItems = this.familiesItems.filter(function (familie) {
        return familie.name.toLowerCase().indexOf(_this.filter.toLowerCase()) > -1;
      });
      return arrayItems || [];
    },
    pageCurrent: {
      get: function get() {
        if (_this2.pageActive) return _this2.pageActive + 1;
        return 1;
      },
      set: function set(newValue) {
        _this2.pageActive = newValue;
      }
    }
  },
  watch: {
    filter: function () {
      var _filter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (val) {
                this.getFamiliesRest(val);
              } else this.getFamiliesRest();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function filter(_x) {
        return _filter.apply(this, arguments);
      }
      return filter;
    }()
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchFamilies', 'createFamilies', 'deleteFamilies'])), {}, {
    openModal: function openModal() {
      this.modal = this.$buefy.modal.open({
        parent: this,
        component: _ModaNewItems.default,
        hasModalCard: true,
        canCancel: ['escape', 'outside'],
        props: {
          item: this.row,
          type: 'families',
          saveItem: this.generateFamilies
        }
      });
    },
    showMsg: function showMsg(msg, type) {
      this.$buefy.toast.open({
        duration: 5000,
        message: msg || "Opera\xE7\xE3o realizada com sucesso",
        type: type || 'is-success'
      });
    },
    getFamiliesRest: function () {
      var _getFamiliesRest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(val) {
        var params, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                parentId: this.row.id,
                page: this.pageActive,
                limit: this.limit
              };
              if (val && this.filter) {
                params.filter = this.filter;
                params.page = 1;
                this.pageActive = 1;
              }
              _context2.n = 1;
              return this.fetchFamilies(params);
            case 1:
              res = _context2.v;
              this.familiesItems = res.data;
              this.totalFamilies = res.total;
              this.$forceUpdate();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getFamiliesRest(_x2) {
        return _getFamiliesRest.apply(this, arguments);
      }
      return getFamiliesRest;
    }(),
    generateFamilies: function () {
      var _generateFamilies = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(item) {
        var numberItens, itemRow, payload, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              numberItens = item.number;
              itemRow = item.item;
              payload = {
                idRow: itemRow.id,
                data: {
                  numberOfFamilies: numberItens
                }
              };
              _context3.n = 1;
              return this.createFamilies(payload);
            case 1:
              res = _context3.v;
              if (res) {
                this.getFamiliesRest();
                this.modal.close();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function generateFamilies(_x3) {
        return _generateFamilies.apply(this, arguments);
      }
      return generateFamilies;
    }(),
    confirmDelete: function confirmDelete(itemRow) {
      var _this3 = this;
      this.$buefy.dialog.confirm({
        title: this.$t('pages.productive_areas.detail.alerts.delete_alert_families_title'),
        message: this.$t('pages.productive_areas.detail.alerts.delete_alert_families_message'),
        cancelText: this.$t('pages.productive_areas.btn_cancel'),
        confirmText: this.$t('pages.productive_areas.btn_delete'),
        type: 'is-danger',
        onConfirm: function onConfirm() {
          return _this3.deleteFamiliesRest(itemRow);
        }
      });
    },
    deleteFamiliesRest: function () {
      var _deleteFamiliesRest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(itemFamilie) {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.deleteFamilies(itemFamilie.id);
            case 1:
              res = _context4.v;
              if (res) this.getFamiliesRest();
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function deleteFamiliesRest(_x4) {
        return _deleteFamiliesRest.apply(this, arguments);
      }
      return deleteFamiliesRest;
    }(),
    openCollapse: function openCollapse(item, index) {
      var data = _.cloneDeep(this.familiesItems);
      data[index].isOpen = true;
      this.$set(this, 'familiesItems', data);
    },
    closedCollapse: function closedCollapse(item, index) {
      this.familiesItems[index].isOpen = false;
    },
    verifyOpen: function verifyOpen(idx) {
      return this.familiesItems.find(function (fam) {
        return fam.id === idx && fam.isOpen;
      });
    },
    openModalEdit: function openModalEdit(item) {
      this.$buefy.modal.open({
        parent: this,
        component: _ModalEditDataArea.default,
        hasModalCard: true,
        canCancel: ['escape', 'outside'],
        props: {
          item: item,
          typeItem: _constants.FAMILIE,
          getRefresh: this.getFamiliesRest
        }
      });
    }
  })
};